<template>
    <div class="time-down">
        {{content}}
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    export default {
        name: "Countdown",
        props: {
            endTime: String,
            contestId:Number,
            labId:String,
            agentUrl:String,
            storagePrefix:String,
            callFunc:{
                type:Function,
                default:function () {}
            },
        },
        data() {
            return {
                content:''
            };
        },
        methods: {
            ...mapActions({
                DeleteContainer: 'container/DeleteContainer',
                setContestLabHeartbeat:'contestAdminContest/setContestLabHeartbeat'
            }),
            countdowm(timestamp){
                let self = this;
                if(self.labId !== undefined && self.labId != null && self.agentUrl !== ''){
                    let timer = setInterval(function(){
                        let nowTime = new Date();
                        let endTime = new Date(timestamp);
                        let t = endTime.getTime() - nowTime.getTime();
                        if(t>0){
                            let day = Math.floor(t/86400000);
                            let hour=Math.floor((t/3600000)%24);
                            let min=Math.floor((t/60000)%60);
                            let sec=Math.floor((t/1000)%60);
                            hour = hour < 10 ? "0" + hour : hour;
                            min = min < 10 ? "0" + min : min;
                            sec = sec < 10 ? "0" + sec : sec;
                            let format = '';
                            if(day > 0){
                                format =  `${day}天${hour}小时${min}分${sec}秒`;
                            }
                            if(day <= 0 && hour > 0 ){
                                format = `${hour}:${min}:${sec}`;
                            }
                            if(day <= 0 && hour <= 0){
                                format =`${min}:${sec}`;
                            }
                            self.content = format;
                        }else{
                            console.log("销毁~~~~");
                            // 销毁容器
                            self.DeleteContainer({
                                data:{
                                    url:self.agentUrl,
                                    lab_id:self.labId,
                                    contest_id:self.contestId,
                                    key:self.storagePrefix,
                                },
                                callback:res=>{
                                    self.callFunc(true);
                                },
                                error:msg=>{
                                    self.callFunc(false);
                                }
                            });
                            self.content = '00:00';
                            self.setContestLabHeartbeat(false);

                            if(window.serviceManager){
                                window.serviceManager.sessions.dispose();
                                window.serviceManager.kernelspecs.dispose();
                                window.serviceManager.sessions._kernelManager.dispose();
                                console.log("close server");
                            }

                            clearInterval(timer);
                        }
                    },1000);
                }
            },
        },
        mounted() {
            let endTime = new Date(this.endTime).getTime();
            this.countdowm(endTime);
        },
        watch: {
            endTime:function(val){
                if(val){
                    let endTime = new Date(val).getTime();
                    this.countdowm(endTime)
                }
            }
        }
    }
</script>

<style scoped>
    .time-down{
        background: #555555;
        width: auto;
        margin-right: 5px;
        color: #fff;
        font-size: 20px;
    }
</style>
